import './calendar-select-default-modal.style.sass';
import template from './calendar-select-default-modal.tpl.pug';

class CalendarSelectDefaultModalController {
    $onInit() {
        this.selected = null;
    }

    select(calendar) {
        this.selected = calendar;
    }

    markAsDone() {
        if (this.selected) {
            this.onClose({
                data: this.selected
            });
        }
    }

    dismiss() {
        this.onDismiss();
    }
}

export default {
    selector: 'dbACalendarSelectDefaultModal',
    template: template(),
    controller: CalendarSelectDefaultModalController,
    bindings: {
        teams: '<',

        onClose: '&',
        onDismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/calendar-select-default-modal/calendar-select-default-modal.cmpt.js